module.exports = __webpack_public_path__ + "images/marketing/peeps/david_baars.jpg";